import { DateStringValue } from '@mantine/dates';
import dayjs from 'dayjs';

export const handleTodayClick = (
  setDate: (date: DateStringValue) => void
): void => {
  setDate(dayjs().format('YYYY-MM-DD'));
};
